import { useMemo } from 'react';

import { useCageController_getCageWinch } from '@/services/hooks';

import { mapCageWinchToDomain } from './mappers';
import type { UseGetCageWinchResult } from './types';

export function useGetCageWinch(
    cageId: number,
    options?: { staleTime?: number }
): UseGetCageWinchResult {
    const winchQuery = useCageController_getCageWinch(cageId, options);

    const data = useMemo(
        () => mapCageWinchToDomain(winchQuery.data?.data),
        [winchQuery.data?.data]
    );

    return {
        ...winchQuery,
        isLoading: winchQuery.isPending,
        data,
    };
}
